import {format} from 'date-fns';
import {BigNumber, ethers} from 'ethers';
import {ReactNode} from 'react';

export async function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms));
}

export function itoh(ipfs?: string | null, preferS3 = false) {
  if (!ipfs) {
    return;
  }

  if (ipfs.startsWith('http')) {
    return ipfs;
  }

  if (ipfs.includes('ipns')) {
    const ipnsMatch = ipfs.match(/(ipns\/.*)/);
    if (ipnsMatch) {
      return `http://ipfs.io/${ipnsMatch[0]}`;
    }
  }

  let host = 'https://lisamona.mypinata.cloud'; // 'https://ipfs.lisamona.xyz';
  if (ipfs.endsWith('.json') && preferS3) {
    host = 'https://s3.lisamona.xyz';
  }

  return `${host}/ipfs/${ipfs.replace('ipfs://', '')}`;
}

export function getHybridId(contentId?: string | null, styleId?: string | null) {
  return ethers.BigNumber.from(
    ethers.utils.solidityKeccak256(
      ['uint256', 'uint256'],
      [ethers.BigNumber.from(contentId || '0'), ethers.BigNumber.from(styleId || '0')],
    ),
  ).toString();
}

type ConditionalWrapperProps = {
  wrap: boolean;
  wrapper: (children: ReactNode) => JSX.Element;
  children: ReactNode;
};
export function ConditionalWrapper(props: ConditionalWrapperProps) {
  return props.wrap ? props.wrapper(props.children) : <>{props.children}</>;
}

export function ethStr(wei?: BigNumber) {
  if (!wei) {
    return '';
  }

  return parseFloat(ethers.utils.formatEther(wei)).toFixed(2);
}

export function dateStr(epoch?: string | number | null) {
  if (!epoch) {
    return '';
  }

  return format(new Date(parseInt(String(epoch), 10) * 1000), 'LLL dd, yyy');
}
